module.exports = __webpack_public_path__ + "static/media/thk.170fca07.png";